import { API_URL, API_VERSION } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useState } from 'react';

const ENDPOINT_URL = '/usr-address/{uuid}';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetMyAccountAddressesDeleteInput = paths[url]['delete']['parameters']['path'];

export interface GetMyAccountAddressesDeleteSuccessResponse {
    data: paths[url]['delete']['responses']['200']['content']['application/json'];
    message: string;
}

/**
 * Requests endpoint to update an address.
 */
export const useGetMyAccountAddressesDelete = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);

    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);

    const request = async (props: GetMyAccountAddressesDeleteInput) => {
        setError(null);
        setSuccess(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL.replace('{uuid}', props.uuid || '')}`, {
                method: 'DELETE',
                headers: getHeaders(),
            });

            const responseBody = await (async () => {
                try {
                    return await response.json();
                } catch (jsonError) {
                    return null;
                }
            })();

            if (!response.ok) {
                const apiError = new Error(responseBody?.message || '') as ApiError;
                apiError.statusCode = response.status;
                throw apiError;
            }

            setSuccess(responseBody?.message || null);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            handleCommonErrors(error);
            error.message && setError(error.message);
        } finally {
            setLastResponseTime(new Date());
        }
    };

    return { request, lastResponseTime, error, success };
};
